import { render, staticRenderFns } from "./serviceProvider.vue?vue&type=template&id=257f20a4&"
import script from "./serviceProvider.vue?vue&type=script&lang=js&"
export * from "./serviceProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports